// Centralizes the pathname-based rules for which chrome (Header/Footer/
// ContactCTA) shows around a route, so App.js doesn't scatter raw
// pathname string checks.
export function useLayoutVisibility(pathname) {
  const isDashboard = pathname.startsWith("/dashboard");
  return {
    showHeader: !isDashboard,
    showFooter: !isDashboard,
    showContactCTA: !isDashboard && pathname !== "/contacts",
  };
}
